/**
 * Created by claudenbach on 3/1/2017.
 */

import { LMEditorService } from './lm-editor.service';
import { LMFieldUtilService } from '@services/utils/lm-field-util.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

import { AppConstants } from '@utils/app.constants';
import { ListResource } from '@resources/list.resource';
import { LMContextService } from '@services/lm-context.service';

export const lmStateFieldSource = (
  lmEditorService: LMEditorService,
  lmFieldUtilService: LMFieldUtilService,
  lmFormatUtilService: LMFormatUtilService,
  lmContextService: LMContextService,
  response: any,
  searchTerm: any,
  sourceArguments: any
) => {

  const columnDef = sourceArguments.column as ListGridColumn;
  const listGridComponent = sourceArguments.grid.settings.userObject();
  const userFolderId = listGridComponent.listSpec?.userFolder;
  const fieldId = columnDef.displayField.fieldId;
  let dataView = sourceArguments.rowData as LMDataView;

  if (!dataView.hasOwnProperty('resourceId')) {
    // coming in as a dropdown on a filter, so no row data with the data view

    // currently, when you pass in the dataViewSet.header, no states will be returned.
    // So if we are in a list where some records exist, grab the first one to pass in
    // so we get actual states.
    const dataViewSet: LMDataViewSet = listGridComponent.dataViewSet;
    if (dataViewSet.data.length > 0) {
      dataView = dataViewSet.data[0];
    } else {
      dataView = dataViewSet.header;
    }
  }

  const listResource = new ListResource({
    resourceId: dataView.resourceId,
    listName: lmEditorService.listSpec.busListSpec.name
  });

  const selectListInfo = columnDef.displayField?.selectListInfo;

  let selectListName = '';
  let selectLink = null;
  if (selectListInfo) {
    selectListName = selectListInfo.selectListName;
    if (selectListInfo.selectLink) {
      selectLink = selectListInfo.selectLink;
    }
  }

  lmFieldUtilService.getUserDefinedStates({
    resource: listResource,
    fieldId,
    dataView,
    selectListName,
    selectLink,
    userFolderId,
    callback: (status, result) => {
      if (status === AppConstants.STATUS_COMPLETED) {
        let states;
        if (lmContextService.userDefinedStatesPageSizeAndIndicator()) {
          if (result && result.hasOwnProperty('states') && Array.isArray(result.states)) {
            states = lmFormatUtilService.fieldStatesToOptionsArray(result.states, true);
          }
        } else {
          if (Array.isArray(result)) {
            states = lmFormatUtilService.fieldStatesToOptionsArray(result, true);
          }
        }
        dataView.fields[ fieldId ].stateValues = states;
        // var selRow = self.getSelectedRows();
        //
        // if (selRow[0] > -1 && self.dataViewSet.data.length > 0)
        //   self.dataViewSet.data[selRow].fields[column.field].stateValues = states;
        //
        // // put the state values on the header as they are used later
        // self.dataViewSet.header.fields[column.field].stateValues = states;
        response(states);
      } else if (status === AppConstants.VIEW_EXCEPTION) {
      }
    }
  });
};
